export default __webpack_public_path__ + "static/media/615.50b6ac13.jpg";